<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="passport"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Passport</label>
              <md-file
                v-model="passport"
                name="passport"
                @change="onFileChange"
              />

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="diploma"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Diploma</label>
              <md-file
                v-model="diploma"
                name="diploma"
                @change="onFileChange"
              />

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="transcript"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Transcript</label>
              <md-file
                v-model="transcript"
                name="transcript"
                @change="onFileChange"
              />

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", required);
extend("email", email);

export default {
  props: {
    user_id: null
  },
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      passport: null,
      diploma: null,
      transcript: null
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        }
        this.$emit("on-validated", res);
        return res;
      });
    },
    onFileChange(e) {
      var file = e.target.files[0] || e.dataTransfer.files[0];
      let fieldName = e.target.name;
      this.$store
        .addUserFile(this.user_id, file, fieldName)
        .then(response => {
          this.$notify({
            message: "Upload Successful",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {});
      this.$notify({
        message: "Uploading...",
        icon: "add_alert",
        type: "info",
        verticalAlign: "top",
        timeout: 3000
      });
      // if (!files.length) return;
      // this.createImage(files[0]);
    }
  }
};
</script>
<style></style>
